import {
  Icon,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Tooltip,
} from '@chakra-ui/react';
import { OutputLayoutField, ProgramConfigCategory } from '@ssar-app/domain';
import { AiOutlineMore } from 'react-icons/ai/index.js';

interface OptionsProps {
  addRowAt: (index: number) => void;
  index: number;
  record: OutputLayoutField;
  removeRows: (id?: string) => void;
  onEdit: (id: string) => void;
  pasteRowsAt: (index: number) => void;
  hidePasteBtns?: boolean;
}

export const Options = (props: OptionsProps) => {
  const {
    addRowAt,
    index,
    record,
    removeRows,
    onEdit,
    pasteRowsAt,
    hidePasteBtns,
  } = props;

  return (
    <Menu>
      <MenuButton
        bg='transparent'
        fontSize='xl'
        minH='unset'
        maxH={5}
        lineHeight={0}
        verticalAlign='middle'
      >
        <Icon as={AiOutlineMore} lineHeight={0} />
      </MenuButton>
      <MenuList rootProps={{ inset: '0 0 auto auto !important' }}>
        <MenuItem onClick={() => addRowAt(index)}>Insert row above</MenuItem>
        <MenuItem onClick={() => addRowAt(index + 1)}>
          Insert row below
        </MenuItem>
        {!hidePasteBtns && (
          <>
            <MenuItem onClick={() => pasteRowsAt(index)}>
              <Tooltip label='Paste above (Ctrl + V + ⬆)' placement='top'>
                Paste above
              </Tooltip>
            </MenuItem>
            <MenuItem onClick={() => pasteRowsAt(index + 1)}>
              <Tooltip label='Paste below (Ctrl + V + ⬇)' placement='top'>
                Paste below
              </Tooltip>
            </MenuItem>
          </>
        )}
        <MenuItem onClick={() => onEdit(record.meta?.id)}>Edit row</MenuItem>
        <MenuItem
          isDisabled={
            record.category !== ProgramConfigCategory.Custom &&
            record.category !== ProgramConfigCategory.ClientInput
          }
          onClick={() => removeRows(record.meta?.id)}
        >
          Delete row
        </MenuItem>
      </MenuList>
    </Menu>
  );
};
